var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("iframe", {
    attrs: {
      width: _vm.width,
      height: _vm.height,
      src: _vm.videoUrl,
      frameborder: "0",
      allowfullscreen: ""
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }